import * as types from '../../constant/actionTypes';

const intialState = {};

export default function (state = intialState, action) {
  switch (action.type) {
  case types.ADJUSTMENT_PAGE_API_SUCCESS: {
    const {
      year,
      month,
      data,
    } = action.payload;
    const newState = {
      ...state,
      [year]: {
        [month]: data,
      },
    };
    return newState;
  }
  default:
    return state;
  }
}




// WEBPACK FOOTER //
// ./src/scenes/Adjustment/reducer.js